/** Back arrow for customize step header (20×20 hit area, stroke #767674). */
export function ConfigurationPanelStepBackIcon() {
  return (
    <svg aria-hidden fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 10H0.75"
        stroke="#767674"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.5 1.25L0.75 10L9.5 18.75"
        stroke="#767674"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

ConfigurationPanelStepBackIcon.displayName = 'ConfigurationPanelStepBackIcon';
